import config from "../clientConfig";

/** Basketmouth / MITO brand red-orange — exact hex used on basketmouth.money. */
export const MITO_RED = "#FB4B14";
export const MITO_RED_HOVER = "#E04312";

export const TRUST_AFFILIATE_ID = "cea8cf3e-701a-45e8-b9e9-9be283229f87";

const NON_TENANT_MITO_HOSTS = new Set([
  "mito.money",
  "www.mito.money",
  "widget.mito.money",
  "staging.mito.money",
  "admin.mito.money",
  "staging-admin.mito.money",
  "dev-admin.mito.money",
]);

/** *.mito.money tenant hosts (trust, future {client}.mito.money) — not widget/admin. */
export function isMitoTenantHost(hostname?: string): boolean {
  if (process.env.REACT_APP_MITO_BRAND === "1") return true;
  if (config.isSubdomain) return true;
  if (typeof window === "undefined" && !hostname) return false;
  const host = (
    hostname ||
    (typeof window !== "undefined" ? window.location.hostname : "")
  ).toLowerCase();
  if (!host.endsWith(".mito.money")) return false;
  return !NON_TENANT_MITO_HOSTS.has(host);
}

function affiliateIdFrom(configOrId?: any): string {
  if (!configOrId) return "";
  if (typeof configOrId === "string") return configOrId.trim().toLowerCase();
  const raw =
    configOrId.affiliateId ||
    configOrId.AffiliateId ||
    configOrId.affiliateid ||
    "";
  return String(raw).trim().toLowerCase();
}

export function shouldUseMitoRed(affiliateConfig?: any): boolean {
  if (process.env.REACT_APP_MITO_BRAND === "1") return true;
  if (isLocalDevHost()) return true;
  if (isMitoTenantHost()) return true;
  const stored =
    typeof window !== "undefined"
      ? (localStorage.getItem("affiliateId") || "").toLowerCase()
      : "";
  const id = affiliateIdFrom(affiliateConfig) || stored;
  return id === TRUST_AFFILIATE_ID;
}

export function resolvePrimaryColour(affiliateConfig?: any): string {
  if (shouldUseMitoRed(affiliateConfig)) return MITO_RED;
  return (
    affiliateConfig?.primaryColourCode ||
    affiliateConfig?.primaryColorCode ||
    affiliateConfig?.PrimaryColourCode ||
    "#000"
  );
}

export function resolveNavBarColour(affiliateConfig?: any): string {
  if (shouldUseMitoRed(affiliateConfig)) return MITO_RED;
  return affiliateConfig?.defaultColourCode || resolvePrimaryColour(affiliateConfig);
}

/** Force Basketmouth / MITO brand red-orange on mito subdomain tenants. */
export function applyMitoBrandToConfig(affiliateConfig?: any): any {
  if (!affiliateConfig || typeof affiliateConfig !== "object") {
    return affiliateConfig;
  }
  if (!shouldUseMitoRed(affiliateConfig)) {
    return affiliateConfig;
  }
  return {
    ...affiliateConfig,
    primaryColourCode: MITO_RED,
    primaryColorCode: MITO_RED,
    PrimaryColourCode: MITO_RED,
    defaultColourCode: MITO_RED,
    secondaryColourCode: MITO_RED,
    affiliateFavicon: null,
  };
}

export const TRUST_PREVIEW_ORIGIN = "https://trust.mito.money";

export function isLocalDevHost(hostname?: string): boolean {
  const host = (
    hostname ||
    (typeof window !== "undefined" ? window.location.hostname : "")
  ).toLowerCase();
  return host === "localhost" || host === "127.0.0.1";
}

if (typeof document !== "undefined" && shouldUseMitoRed()) {
  document.documentElement.classList.add("mito-brand", "mito-theme-orange");
}

/** Origin the API should bind for local Trust preview. */
export function resolveAffiliateDomainHeader(): string | undefined {
  if (typeof window === "undefined") return undefined;
  if (isLocalDevHost() || process.env.REACT_APP_MITO_BRAND === "1") {
    return TRUST_PREVIEW_ORIGIN;
  }
  if (window.location?.origin) return window.location.origin;
  return undefined;
}
